import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qd-challan-form',
  templateUrl: './qd-challan-form.component.html',
  styleUrls: ['./qd-challan-form.component.css']
})
export class QdChallanFormComponent implements OnInit {
  title="Quotation Delivery Challan";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/purchase/quotation-delivery-challan/qd-challan-form/qd-challan-form.component.ts